// extracted by mini-css-extract-plugin
export default {"wrapper":"details_header___wrapper___aa9523f8","header":"details_header___header___ecab55a3","id":"details_header___id___eb8049b0"};